import React, {} from 'react';
import {Bar} from 'react-chartjs-2';
import Loader from 'components/Loader';

const EmptySentimentChart = ({hideBasedOnResultsLength}) => {
    const clickData = {
        datasets: null,
    };
    const mobileView = window.innerWidth < 650;

    return (
        <div className="d-flex flex-column position-relative" style={{flex: 1, paddingTop: '15px'}}>
            <div className="d-flex justify-content-between align-items-center">
                <div className="entity-chart-title mb-2">Sentiments (5 Day SMA)</div>
            </div>
                <div
                    className="d-flex align-items-center justify-content-center h-100 w-100 position-absolute"
                    style={{
                        fontSize: '.9rem',
                        padding: '3rem',
                        fontWeight: '500'
                        // textAlign: 'center',
                        // top: '10%',
                    }}
                >
                    {hideBasedOnResultsLength ?
                        <div>Not yet enough articles to detect Sentiments SMA.</div>
                        :
                        <div>No chart content is available yet. Please check again later for updated content.</div>
                    }
                </div>
            <div
                style={{
                    opacity: 0.5,
                    maxHeight: mobileView ? 500 : 280,
                    alignItems: 'center',
                }}
            >
                <Bar
                    data={clickData}
                    height={mobileView ? 500 : 280}
                    responsive={false}
                    options={{
                        fillOpacity: 0.3,
                        legend: {
                            display: true,
                        },
                        maintainAspectRatio: false,
                        scales: {
                            xAxes: [
                                {
                                    ticks: {
                                        autoSkip: true,
                                        maxTicksLimit: 7,
                                    },
                                },
                            ],
                            yAxes: [
                                {
                                    ticks: {
                                        beginAtZero: true,
                                    },
                                },
                            ],
                        },
                        plugins: {
                            datalabels: {
                                display: true,
                                color: 'white',

                                borderRadius: 6,
                                font: {
                                    size: 12,
                                },
                                formatter: function(value) {
                                    if(value > 0) {
                                        return value;
                                    } else {
                                        return null;
                                    }
                                },
                            },
                        },
                    }}
                />
            </div>
        </div>
    );
};

export default EmptySentimentChart;